import { PropertyEditableInComponent } from "@/types/components";
import { documentStore, uiStore } from "@/store/store";
import { TreeNode } from "@/types/tree";
import { v4 as uuidV4 } from "uuid";
import defensiveCopy from "@/util/defensive-copy";

export function updateEditableProperty(
  controlPath: string,
  propertyEditableInComponent: PropertyEditableInComponent
) {
  if (!uiStore.activeElement) return;

  const editableProperties = defensiveCopy(
    getPropertiesEditableInComponent(uiStore.activeElement)
  );

  const index = editableProperties.findIndex(editableProperty => {
    return editableProperty.controlPath === controlPath;
  });

  if (index === -1) return;

  editableProperties[index] = {
    ...propertyEditableInComponent
  };

  setPropertiesEditableInComponent(
    uiStore.activeElement.id,
    editableProperties
  );
}

export function toggleEditablePropertyForControlPath(controlPath: string) {
  if (!uiStore.activeElement) return;

  const editableProperties = defensiveCopy(
    getPropertiesEditableInComponent(uiStore.activeElement)
  );

  const index = editableProperties.findIndex(editableProperty => {
    return editableProperty.controlPath === controlPath;
  });

  if (index !== -1) {
    if ("enabled" in editableProperties[index]) {
      editableProperties[index].enabled = !editableProperties[index].enabled;
    } else {
      editableProperties[index].enabled = false;
    }
  } else {
    editableProperties.push({
      enabled: true,
      label: "",
      controlPath: controlPath,
      propertyKey: uuidV4()
    });
  }

  setPropertiesEditableInComponent(
    uiStore.activeElement.id,
    editableProperties
  );
}

export function isControlPathAnEditableProperty(controlPath: string) {
  if (!uiStore.activeElement) return false;

  const editableProperties = getPropertiesEditableInComponent(
    uiStore.activeElement
  );

  const foundProperty = editableProperties.find(editableProperty => {
    return editableProperty.controlPath === controlPath;
  });

  if (foundProperty && "enabled" in foundProperty) {
    return foundProperty.enabled;
  }

  return !!foundProperty;
}

export function setPropertiesEditableInComponent(
  treeNodeId: TreeNode["id"],
  editableProperties: PropertyEditableInComponent[]
) {
  // i'm getting a console error when calling this - do i use throttledPropertyChange instead?

  documentStore.propertyChangedMutation({
    elementId: treeNodeId,
    path: "meta.component.editableProperties",
    value: editableProperties,
    meta: {
      snapshotLabel: "TODO" // generateDocumentStorePropertyChangeSnapshotLabel
    }
  });
}

export function getPropertiesEditableInComponent(
  node: TreeNode
): PropertyEditableInComponent[] {
  return node?.data.properties?.meta?.component?.editableProperties ?? [];
}
